import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from "yup";
import { TailSpin } from 'react-loader-spinner';


const GroupLogin = ({  }) => {

  const [loading, setLoading] = useState(false);

  const initialValues = {
    groupCode : '',
    email : ''
  }

  const validationSchema = Yup.object().shape({
    email : Yup.string().email().required("Email is required"),
    groupCode : Yup.string().required("Group code is required")
  });

  const submitForm = (values) => {

  }

  return (
    <Container fluid="lg" className='wrapper'>
      <Row className="RegisterMemberRow">

        <h1>Group Registration</h1>

          <Col xs={12} md={6} className="section left-divider">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onsubmit={submitForm}
            >
              {({values, handleChange, handleSubmit, errors, touched, handleBlur}) => (
                <Form noValidate onSubmit={handleSubmit}>

                  <Row className="mb-3">
                    <Form.Group as={Col} md="12" controlId="validationCustom01">
                      <Form.Label>Group Code</Form.Label>
                        <Form.Control
                          required
                          name="groupCode"
                          type="text"
                          placeholder=""
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.groupCode}
                          isValid={touched.groupCode && !errors.groupCode}
                          isInvalid={!!errors.groupCode}
                        />
                        <Form.Control.Feedback type="invalid">{errors.groupCode}</Form.Control.Feedback>
                    </Form.Group>
                  </Row>

                  <Row className="mb-3">
                    <Form.Group as={Col} md="12" controlId="validationCustom01">
                      <Form.Label>Email</Form.Label>
                        <Form.Control
                          required
                          name="email"
                          type="text"
                          placeholder="Email of person in charge"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                          isValid={touched.email && !errors.email}
                          isInvalid={!!errors.email}
                        />
                        <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                    </Form.Group>
                  </Row>

                  <Row className="p-3">
                    <Button type="submit" size="lg" className="red-button  d-flex justify-content-center">
                      Login &nbsp;
                      <TailSpin
                        height="30"
                        width="30"
                        color="#ccc"
                        ariaLabel="tail-spin-loading"
                        radius="1"
                        wrapperStyle={{}}
                        wrapperClass="loader"
                        visible={loading}
                      />
                    </Button>
                </Row>

                </Form>
              )}
            </Formik>
          </Col>

          <Col xs={12} md={6} className="section">
            <div className="loginButtonSection">
              <Row>
                <Col sm={12} md={12} className='loginRightSection p-4' >
                  <h5>Join Us</h5>
                  <h1>21 September 2025</h1>
                  <h4>Padang Merdeka, Kuching, Sarawak</h4>                   
                </Col>
              </Row>
            </div>
          </Col>
        
      </Row>
    </Container>
  );
}

export default GroupLogin;